import React, { useCallback, useEffect } from 'react';
import { motion, useMotionTemplate, useMotionValue } from 'motion/react';
import { cn } from '../../lib/utils';

export function MagicCard(props) {
  const {
    children,
    className,
    gradientSize = 200,
    gradientColor = 'rgba(250, 204, 21, 0.08)',
    gradientOpacity = 0.5,
    gradientFrom = 'rgba(250, 204, 21, 0.4)',
    gradientTo = 'rgba(234, 179, 8, 0.2)',
    onClick,
  } = props;

  const mouseX = useMotionValue(-gradientSize);
  const mouseY = useMotionValue(-gradientSize);

  const reset = useCallback(() => {
    const off = -gradientSize;
    mouseX.set(off);
    mouseY.set(off);
  }, [mouseX, mouseY, gradientSize]);

  const handlePointerMove = useCallback(
    (e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      mouseX.set(e.clientX - rect.left);
      mouseY.set(e.clientY - rect.top);
    },
    [mouseX, mouseY]
  );

  useEffect(() => {
    reset();
  }, [reset]);

  return (
    <motion.div
      onClick={onClick}
      className={cn(
        'group relative isolate overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900/80 transition-all duration-300 shadow-sm dark:shadow-none hover:border-amber-400/60 dark:hover:border-amber-400/40',
        onClick && 'cursor-pointer',
        className
      )}
      onPointerMove={handlePointerMove}
      onPointerLeave={reset}
      style={{
        background: useMotionTemplate`
          linear-gradient(var(--color-background) 0 0) padding-box,
          radial-gradient(${gradientSize}px circle at ${mouseX}px ${mouseY}px,
            ${gradientFrom},
            ${gradientTo},
            transparent 100%
          ) border-box
        `,
      }}
    >
      <div className="bg-white dark:bg-slate-900/90 absolute inset-px z-20 rounded-[inherit]" />

      <motion.div
        suppressHydrationWarning
        className="pointer-events-none absolute inset-px z-30 rounded-[inherit] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background: useMotionTemplate`
            radial-gradient(${gradientSize}px circle at ${mouseX}px ${mouseY}px,
              ${gradientColor},
              transparent 100%
            )
          `,
          opacity: gradientOpacity,
        }}
      />
      <div className="relative z-40">{children}</div>
    </motion.div>
  );
}
